import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const phoneNumber = "+5542999417643"; // Replace with actual WhatsApp number
  const message = encodeURIComponent(
    "Olá! Gostaria de atendimento!",
  );
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:bg-[#128C7E] transition-colors z-50"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
